/** Shared layout detection for admin homepage product sections */

const SLIDER_TYPES = new Set([
  'product_slider',
  'product-slider',
  'trending_products',
  'recently_viewed',
  'custom_products',
]);

export type HomepageSectionLike = {
  type?: string;
  layoutMode?: 'grid' | 'slider';
  config?: { layout?: string };
};

export function isSliderLayout(section: HomepageSectionLike): boolean {
  if (section.layoutMode === 'slider') return true;
  if (section.layoutMode === 'grid') return false;
  if (section.config?.layout === 'slider') return true;
  if (section.config?.layout === 'grid') return false;
  return SLIDER_TYPES.has(section.type || '');
}

export function getProductsPerRow(section: HomepageSectionLike): number {
  const n = (section as { config?: { productsPerRow?: number } }).config?.productsPerRow;
  return typeof n === 'number' && n > 0 ? n : 4;
}
